<template>
    <button @click.prevent="openModal">{{ __(text) }}</button>
</template>

<script>
export default {
    props: {
        address: {
            required: false,
            type:Object
        }
    },
    computed: {
        text(){
            return (this.address) ? 'Edit' : 'Add address'
        }
    },
    methods: {
        openModal(){
            this.$modal.show('address-modal');

            if(this.address){
                this.$root.$emit('edit-address',this.address);
            }
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// resources/js/components/Account/address-button.vue